import axios from 'axios';

const api = axios.create({
  baseURL: 'https://estoque-back.redenilf.com.br',
});

export default api;
